import React from 'react';
import { NavLink } from 'react-router-dom';
import image from './../../images/img1.png';
import "./ImageOnTop.css";
import styled from 'styled-components';

// Styled Components
const Card = styled.div`
  border: 1px solid #ddd; /* Light border for card */
  border-radius: 8px;
  width: 400px; /* Set a fixed width for each card */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column; /* Stack content vertically */
  background-color: #fff;
  position: relative;
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center; /* Center the image horizontally */
  align-items: center; /* Align image vertically */
  padding: 15px;
`;

const ProductImage = styled.img`
  max-width: 100%; /* Responsive image width */
  height: auto; /* Maintain aspect ratio */
  max-height: 180px; /* Limit the height of the image */
  object-fit: contain; /* Ensures proper alignment */
`;

const TextContainer = styled.div`
  padding: 15px;
  text-align: left; /* Align text to the left */
`;

const ProductTitle = styled.h3`
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
`;

const ProductCategory = styled.h6`
  font-size: 14px;
  color: #555;
  margin-bottom: 10px;
`;

const ProductLabel = styled.p`
  font-size: 12px;
  color: #777;
  margin-bottom: 10px;
`;

const SeeMoreLink = styled(NavLink)`
  color: #007bff;
  font-size: 14px;

  cursor: pointer;

  &:hover {
    color: #0056b3;
  }
`;

const CompareProduct = styled.p`
  font-size: 14px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 5px;
  text-decoration: underline;
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  margin-right: 5px;
`;

const ImageOnTop = ({ product }) => {
  return (
    <div key={product.productid} className="card product-card-top mx-2">
      <div className="product-content-top">
        <ImageContainer className="image-container-top">
          <ProductImage
            src={image}
            alt={product.categoryName || "Product Image"}
          />
        </ImageContainer>
        <TextContainer>
          <ProductTitle>
            {product.productId || "No Product No"}
          </ProductTitle>
          <ProductCategory className="product-category-top">{product.categoryName || "No Name"}</ProductCategory>
          <ProductLabel className="product-label-top">{product.productLabel || "No Model"}</ProductLabel>
          <NavLink
            to={`/productdetails/${product.productId}`}
            state={{ productlabel: product.productlabel }}
          >
            <SeeMoreLink >See more...</SeeMoreLink>
          </NavLink>
        </TextContainer>
      </div>
      <CompareProduct>
        <Checkbox type="checkbox" />
        Compare
      </CompareProduct>
    </div>
  );
};

export default ImageOnTop;
